import api from "../services/api";

import { HttpStatusCode, INotificacao, IRecebedor, ISearchRequest, ISearchResponse } from "../interfaces";

export interface INotificacaoListModel {
    id: string;
    criadaEm: string;
    descricao: string;
    visualizada: boolean;
}

export interface IRecebedorListModel {
    recebedor: string;
    visualizada: boolean;
    visualizadaEm: string;
    removida: boolean;
    removidaEm: string;
}

interface INotificacaoGetRequest {
    id: string;
    includeRecebedores: boolean;
}

interface INotificacaoPostModel {
    descricao: string;
    mensagem: string;
    pessoaPendente?: string;
    recebedores: Pick<IRecebedor, "recebedorId" | "userLevel">[];
}

interface INotificacaoResponse {
    notificacao: INotificacao;
    message: string;
}

class NotificationRepository {
    public Create = async ({ descricao, mensagem, recebedores, pessoaPendente }: INotificacaoPostModel): Promise<INotificacaoResponse> => {
        const response = await api.post<INotificacaoResponse>("notificacao", {
            descricao,
            mensagem,
            recebedores,
            pessoaPendente
        });

        return response.data;
    }

    public Remove = async (id: string): Promise<boolean> => {
        const response = await api.delete(`notificacao/${id}`);

        return response.status === HttpStatusCode.NoContent;
    }

    public SetViewed = async (id: string): Promise<INotificacaoResponse> => {
        const response = await api.patch<INotificacaoResponse>(`notificacao/${id}/view`);

        return response.data;
    }

    public SetRemoved = async (id: string): Promise<INotificacaoResponse> => {
        const response = await api.patch<INotificacaoResponse>(`notificacao/${id}/remove`);

        return response.data;
    }

    public Count = async (): Promise<number> => {
        const response = await api.get<number>("notificacao/count");

        return response.data;
    }

    public GetById = async ({ id, includeRecebedores }: INotificacaoGetRequest): Promise<INotificacao> => {
        const response = await api.get<INotificacao>(`notificacao/${id}`, {
            params: {
                recebedores: includeRecebedores
            }
        });

        return response.data;
    }

    public GetByPendingPersonId = async (id: string): Promise<INotificacao> => {
        const response = await api.get<INotificacao>(`notificacao/pending/${id}`);
        return response.data;
    }

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<INotificacaoListModel>> => {

        const response = await api.get<ISearchResponse<INotificacaoListModel>>("notificacao", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public ListAdmin = async (searchRequest: ISearchRequest): Promise<ISearchResponse<INotificacaoListModel>> => {

        const response = await api.get<ISearchResponse<INotificacaoListModel>>("notificacao/admin", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public ListReceivers = async (id: string, searchRequest: ISearchRequest): Promise<ISearchResponse<IRecebedorListModel>> => {

        const response = await api.get<ISearchResponse<IRecebedorListModel>>(`notificacao/${id}/admin/recebedores`, {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }
}

const notificationRepository = new NotificationRepository();
export default notificationRepository;
